<style>
.main-header {
background-color: #141413;
color: white;
}
</style>

<script>
import Footer from '@/components/shared/footer/footer'

export default {
  name: 'Vsrci',
  components: {
    'app-footer': Footer
  },
  mounted () {
    document.title = 'VISA SRCi'
    let visaScript = document.createElement('script')
    visaScript.src = 'https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/integration/v1/sdk.js'
    visaScript.type = 'text/javascript'
    document.head.appendChild(visaScript)
  }
}
</script>
<template>
  <div>
    <header class="main-header p-lg-0 container mt-3 mb-2">
      <div class="row">
        <div class="col-6 col-sm-3">
          <img
            class="header-logo cursor-pointer"
            src="../../assets/images/header_logo.png"
          >
        </div>
        <div class="col-12 col-sm-6 text-center">
          <h1
            class="header-title font-weight-bold cursor-pointer"
          >
            VISA SRCi
          </h1>
        </div>
      </div>
    </header>
    <div class="container container-height">
      <div class="row mt-4">
        <div class="col text-center mt-5">
          <img
            alt="Click to Pay"
            class="v-button"
            role="button"
            src="https://sandbox.secure.checkout.visa.com/wallet-services-web/xo/button.png"
          >
        </div>
      </div>
    </div>
    <app-footer/>
  </div>
</template>
